
//old code 1/10
// import React, { useState, useRef, useEffect } from 'react';
// import './FilterPage.css';
// import { FiFilter } from 'react-icons/fi';
// import { useDispatch } from 'react-redux';
// import { resetBillingSearchAndFilters } from '../../redux/slices/AllBillingSlice';

// const FilterBillPage = ({
//     options=[],
//     value=[],
//     onChange,
//     placeholder,
//     selectedStartDate,
//     selectedEndDate,
//     onDateRangeSelected,
//     onClearDate,
//     loadingServices = false,
//     loadingProviders = false,
//     hasDues,
//     onToggleDues,
//     products=[],
//     onProductSelectionChange
// }) => {
//     const [isOpen, setIsOpen] = useState(false);
//     const [activeSection, setActiveSection] = useState(null);
//     const [searchQuery, setSearchQuery] = useState('');
//     const [tempValue, setTempValue] = useState(value || []);
//     const [tempStartDate, setTempStartDate] = useState(selectedStartDate || '');
//     const [tempEndDate, setTempEndDate] = useState(selectedEndDate || '');
//     const [tempHasDues, setTempHasDues] = useState(hasDues || false);
//     const [tempSelectedProducts, setTempSelectedProducts] = useState([]);
//     const selectRef = useRef(null);
//     const dispatch = useDispatch();

//     const handleToggle = () => {
//         setIsOpen(!isOpen);
//         if (!isOpen && options?.length > 0) {
//             setActiveSection('Date Range');
//             setSearchQuery('');
//             setTempValue(value);
//             setTempStartDate(selectedStartDate);
//             setTempEndDate(selectedEndDate);
//             setTempHasDues(hasDues);
//             setTempSelectedProducts(value.filter(val => 
//                 products.some(product => product._id === val)
//             ));
//         }
//     };

//     const handleDuesToggle = (e) => {
//         setTempHasDues(e.target.checked);
//     };

//     const handleTempOptionChange = (option) => {
//         const newValues = tempValue.includes(option)
//             ? tempValue.filter((val) => val !== option)
//             : [...tempValue, option];
//         setTempValue(newValues);
//     };

//     const handleProductSelect = (productId) => {
//         const newSelectedProducts = tempSelectedProducts.includes(productId)
//             ? tempSelectedProducts.filter(id => id !== productId)
//             : [...tempSelectedProducts, productId];
        
//         setTempSelectedProducts(newSelectedProducts);
        
//         // Update the main tempValue as well
//         const newValues = tempValue.includes(productId)
//             ? tempValue.filter(val => val !== productId)
//             : [...tempValue, productId];
//         setTempValue(newValues);
//     };

//     const handleSelectAllProducts = () => {
//         const allProductIds = getActiveSectionItems().map(product => product._id || product.value);
        
//         if (tempSelectedProducts?.length === allProductIds?.length) {
//             // Deselect all
//             const newValues = tempValue.filter(val => !allProductIds.includes(val));
//             setTempValue(newValues);
//             setTempSelectedProducts([]);
//         } else {
//             // Select all
//             const newValues = [...new Set([...tempValue, ...allProductIds])];
//             setTempValue(newValues);
//             setTempSelectedProducts(allProductIds);
//         }
//     };

//     const handleClear = () => {
//         setTempValue([]);
//         setTempStartDate('');
//         setTempEndDate('');
//         setTempHasDues(false);
//         setTempSelectedProducts([]);
//         dispatch(resetBillingSearchAndFilters());
//     };

//     const handleDateChange = (startDate, endDate) => {
//         setTempStartDate(startDate);
//         setTempEndDate(endDate);
//     };

//     const handleClickOutside = (event) => {
//         if (selectRef.current && !selectRef.current.contains(event.target)) {
//             setIsOpen(false);
//         }
//     };

//     useEffect(() => {
//         document.addEventListener('mousedown', handleClickOutside);
//         return () => {
//             document.removeEventListener('mousedown', handleClickOutside);
//         };
//     }, []);

//     const hasActiveFilters = () => {
//         return tempValue?.length > 0 || (tempStartDate && tempEndDate) || hasDues;
//     };

//     const getFilterCount = (sectionTitle) => {
//         if (sectionTitle === 'Date Range') {
//             return (tempStartDate && tempEndDate) ? 1 : 0;
//         }
//         if (sectionTitle === 'Dues') {
//             return tempHasDues ? 1 : 0;
//         }
//         if (sectionTitle === 'Products') {
//             return tempSelectedProducts?.length;
//         }

//         const section = options?.find(opt => opt.title === sectionTitle);
//         if (!section) return 0;

//         return tempValue?.filter(val =>
//             section.items.some(item =>
//                 item.value === val || item._id === val
//             )
//         )?.length;
//     };

//     const getActiveSectionItems = () => {
//         if (!activeSection) return [];
        
//         // Handle Products section
//         if (activeSection === 'Products') {
//             let productItems = products;
            
//             // Apply search filter if there's a search query
//             if (searchQuery) {
//                 productItems = productItems?.filter(product =>
//                     (product.consumeableProductName || product.productName || '')
//                         .toLowerCase()
//                         .includes(searchQuery.toLowerCase())
//                 );
//             }
            
//             return productItems;
//         }
        
//         const section = options.find(opt => opt.title === activeSection);
//         if (!section) return [];

//         const items = section.items || [];

//         if (['Services', 'Service Providers'].includes(activeSection) && searchQuery) {
//             return items.filter(item => {
//                 const label = item.label || item.name || item.serviceName || '';
//                 return label.toLowerCase().includes(searchQuery.toLowerCase());
//             });
//         }

//         return items;
//     };

//     const renderLoadingState = () => (
//         <div className="loading-state">
//             <div className="loading-spinner"></div>
//             <span>Loading...</span>
//         </div>
//     );

//     useEffect(() => {
//         setTempValue(value);
//         setTempStartDate(selectedStartDate);
//         setTempEndDate(selectedEndDate);
//         setTempSelectedProducts(value?.filter(val => 
//             products.some(product => product._id === val)
//         ));
//     }, [value, selectedStartDate, selectedEndDate, products]);
//     console.log("options", options);
// console.log("value", value);
// console.log("products", products);
// console.log("tempValue", tempValue);

//     return (
//         <div className="myntra-filter">
//             <div
//                 className={`filter-header ${hasActiveFilters() ? 'has-filters' : ''}`}
//                 onClick={handleToggle}
//             >
//                 <FiFilter className="filter-icon" size={24} />
//                 <span className="filter-placeholder">
//                     {placeholder}
//                     {hasActiveFilters() && (
//                         <span className="filter-count-badge">
//                             {tempValue?.length + ((tempStartDate && tempEndDate) ? 1 : 0) + (hasDues ? 1 : 0)}
//                         </span>
//                     )}
//                 </span>
//             </div>

//             {isOpen && (
//                 <div className="filter-overlay">
//                     <div className="filter-container" style={{ width: '700px' }} ref={selectRef}>
//                         <div className="filter-sidebar">
//                             <div className="filter-title">Filters</div>
                            
//                             {/* Date Range at the top */}
//                             <div
//                                 className={`sidebar-item ${activeSection === 'Date Range' ? 'active' : ''}`}
//                                 onClick={() => {
//                                     setActiveSection('Date Range');
//                                     setSearchQuery('');
//                                 }}
//                             >
//                                 <span>Date Range</span>
//                                 {getFilterCount('Date Range') > 0 && (
//                                     <span className="filter-badge">1</span>
//                                 )}
//                             </div>

//                             {/* Dues filter */}
//                             <div
//                                 className={`sidebar-item ${activeSection === 'Dues' ? 'active' : ''}`}
//                                 onClick={() => {
//                                     setActiveSection('Dues');
//                                     setSearchQuery('');
//                                 }}
//                             >
//                                 <span>Dues</span>
//                                 {hasDues && <span className="filter-badge">1</span>}
//                             </div>

//                             {/* Other filters including Products */}
//                             {options.map((section) => {
//                                 const count = getFilterCount(section.title);
//                                 return (
//                                     <div
//                                         key={section.title}
//                                         className={`sidebar-item ${activeSection === section.title ? 'active' : ''}`}
//                                         onClick={() => {
//                                             setActiveSection(section.title);
//                                             setSearchQuery('');
//                                         }}
//                                     >
//                                         <span>{section.title}</span>
//                                         {count > 0 && <span className="filter-badge">{count}</span>}
//                                     </div>
//                                 );
//                             })}
//                         </div>

//                         <div className="filter-content">
//                             <div className="filter-footer">
//                                 <button
//                                     className="clear-btn"
//                                     onClick={handleClear}
//                                     disabled={!hasActiveFilters()}
//                                 >
//                                     CLEAR ALL
//                                 </button>
//                                 <button
//                                     className="apply-btn"
//                                     onClick={() => {
//                                         onChange(tempValue);
//                                         onDateRangeSelected(tempStartDate, tempEndDate);
//                                         onToggleDues(tempHasDues);
//                                         if (onProductSelectionChange) {
//                                             onProductSelectionChange(tempSelectedProducts);
//                                         }
//                                         setIsOpen(false);
//                                     }}
//                                 >
//                                     APPLY
//                                 </button>
//                             </div>

//                             <div className="scrollable-content">
//                                 {/* Dues content section */}
//                                 {activeSection === 'Dues' && (
//                                     <>
//                                         <div className="content-section">
//                                             <div className="content-title">Dues</div>
//                                         </div>
//                                         <div className="content-options">
//                                             <div className="option-item">
//                                                 <input
//                                                     type="checkbox"
//                                                     id="dues-checkbox"
//                                                     checked={tempHasDues}
//                                                     onChange={handleDuesToggle}
//                                                 />
//                                                 <label htmlFor="dues-checkbox">
//                                                     Show only bills with dues
//                                                 </label>
//                                             </div>
//                                         </div>
//                                     </>
//                                 )}

//                                 {/* Date Range content section */}
//                                 {activeSection === 'Date Range' && (
//                                     <>
//                                         <div className="content-section">
//                                             <div className="content-title">Date Range</div>
//                                         </div>
//                                         <div className="date-range-container">
//                                             <div className="date-input-group">
//                                                 <label>From</label>
//                                                 <input
//                                                     type="date"
//                                                     value={tempStartDate || ''}
//                                                     onChange={(e) => handleDateChange(e.target.value, tempEndDate)}
//                                                 />
//                                             </div>
//                                             <div className="date-input-group">
//                                                 <label>To</label>
//                                                 <input
//                                                     type="date"
//                                                     value={tempEndDate || ''}
//                                                     onChange={(e) => handleDateChange(tempStartDate, e.target.value)}
//                                                 />
//                                             </div>
//                                         </div>
//                                     </>
//                                 )}

//                                 {/* Products content section */}
//                                 {activeSection === 'Products' && (
//                                     <>
//                                         <div className="content-section">
//                                             <div className="content-title">Products</div>
//                                             <div className="search-input-container">
//                                                 <input
//                                                     type="text"
//                                                     placeholder="Search products..."
//                                                     value={searchQuery}
//                                                     onChange={(e) => setSearchQuery(e.target.value)}
//                                                     className="search-input wide-search"
//                                                 />
//                                             </div>
//                                         </div>
//                                         <div className="content-options">
//                                             {getActiveSectionItems()?.length === 0 ? (
//                                                 <div className="no-results">No results found.</div>
//                                             ) : (
//                                                 <>
//                                                     <div className="option-item select-all">
//                                                         <input
//                                                             type="checkbox"
//                                                             id="select-all-products"
//                                                             checked={tempSelectedProducts?.length === getActiveSectionItems()?.length && getActiveSectionItems()?.length > 0}
//                                                             onChange={handleSelectAllProducts}
//                                                         />
//                                                         <label htmlFor="select-all-products">
//                                                             Select All
//                                                         </label>
//                                                     </div>
//                                                     {getActiveSectionItems().map((product) => (
//                                                         <div key={product._id || product.value} className="option-item">
//                                                             <input
//                                                                 type="checkbox"
//                                                                 id={product._id || product.value}
//                                                                 checked={tempSelectedProducts.includes(product._id || product.value)}
//                                                                 onChange={() => handleProductSelect(product._id || product.value)}
//                                                             />
//                                                             <label htmlFor={product._id || product.value}>
//                                                                 {product.consumeableProductName || product.productName || product.label}
//                                                             </label>
//                                                         </div>
//                                                     ))}
//                                                 </>
//                                             )}
//                                         </div>
//                                     </>
//                                 )}

//                                 {/* Other filters content sections */}
//                                 {activeSection && activeSection !== 'Date Range' && activeSection !== 'Dues' && activeSection !== 'Products' && (
//                                     <>
//                                         <div className="content-section">
//                                             <div className={`content-title ${activeSection === 'Services' ? 'bold-title' : ''}`}>
//                                                 {activeSection}
//                                             </div>
//                                             {(activeSection === 'Services' || activeSection === 'Service Providers') && (
//                                                 <div className="search-input-container">
//                                                     <input
//                                                         type="text"
//                                                         placeholder={`Search ${activeSection.toLowerCase()}...`}
//                                                         value={searchQuery}
//                                                         onChange={(e) => setSearchQuery(e.target.value)}
//                                                         className={`search-input ${activeSection === 'Services' || activeSection === 'Service Providers' ? 'wide-search' : ''}`}
//                                                     />
//                                                 </div>
//                                             )}
//                                         </div>

//                                         <div className="content-options">
//                                             {(activeSection === 'Services' && loadingServices) ||
//                                                 (activeSection === 'Service Providers' && loadingProviders) ? (
//                                                 renderLoadingState()
//                                             ) : (
//                                                 getActiveSectionItems()?.length === 0 ? (
//                                                     <div className="no-results">No results found.</div>
//                                                 ) : (
//                                                     getActiveSectionItems().map((option) => (
//                                                         <div key={option.value || option._id} className="option-item">
//                                                             <input
//                                                                 type="checkbox"
//                                                                 id={option.value || option._id}
//                                                                 checked={tempValue.includes(option.value || option._id)}
//                                                                 onChange={() => handleTempOptionChange(option.value || option._id)}
//                                                             />
//                                                             <label htmlFor={option.value || option._id}>
//                                                                 {option.label || option.name || option.serviceName}
//                                                             </label>
//                                                         </div>
//                                                     ))
//                                                 )
//                                             )}
//                                         </div>
//                                     </>
//                                 )}
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default FilterBillPage;

import React, { useState, useRef, useEffect } from 'react';
import './FilterPage.css';
import { FiFilter } from 'react-icons/fi';
import { useDispatch } from 'react-redux';
import { resetBillingSearchAndFilters } from '../../redux/slices/AllBillingSlice';

const FilterBillPage = ({
    options=[],
    value=[],
    onChange,
    placeholder,
    selectedStartDate,
    selectedEndDate,
    onDateRangeSelected,
    onClearDate,
    loadingServices = false,
    loadingProviders = false,
    hasDues,
    onToggleDues,
    hasAvailability,
    onToggleAvailability,
    products=[],
    onProductSelectionChange
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [activeSection, setActiveSection] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [tempValue, setTempValue] = useState(value || []);
    const [tempStartDate, setTempStartDate] = useState(selectedStartDate || '');
    const [tempEndDate, setTempEndDate] = useState(selectedEndDate || '');
    const [tempHasDues, setTempHasDues] = useState(hasDues || false);
    const [tempAvailablity, setTempAvailablity] = useState(hasAvailability);
    const [tempSelectedProducts, setTempSelectedProducts] = useState([]);
    const [tempSelectedServices, setTempSelectedServices] = useState([]); // Add this line
    const selectRef = useRef(null);
    const dispatch = useDispatch();

    const handleToggle = () => {
        setIsOpen(!isOpen);
        if (!isOpen && options?.length > 0) {
            setActiveSection('Date Range');
            setSearchQuery('');
            setTempValue(value);
            setTempStartDate(selectedStartDate);
            setTempEndDate(selectedEndDate);
            setTempHasDues(hasDues);
            setTempAvailablity(hasAvailability)
            setTempSelectedProducts(value.filter(val => 
                products.some(product => product._id === val)
            ));
            setTempSelectedServices(value.filter(val =>
                options.find(opt => opt.title === 'Services')?.items.some(service => service.value === val || service._id === val)
            ));
        }
    };

        const handleAvailablityToggle = (e) => {
        setTempAvailablity(e.target.checked);
    };

    const handleDuesToggle = (e) => {
        setTempHasDues(e.target.checked);
    };

    const handleTempOptionChange = (optionValue, sectionTitle) => {
        const newValues = tempValue.includes(optionValue)
            ? tempValue.filter((val) => val !== optionValue)
            : [...tempValue, optionValue];
        setTempValue(newValues);

        // Update tempSelectedServices or tempSelectedProducts based on section
        if (sectionTitle === 'Services') {
            const currentServiceItems = options.find(opt => opt.title === 'Services')?.items || [];
            const newSelectedServices = newValues.filter(val =>
                currentServiceItems.some(service => (service.value === val || service._id === val))
            );
            setTempSelectedServices(newSelectedServices);
        } else if (sectionTitle === 'Products') {
            const newSelectedProducts = newValues.filter(val =>
                products.some(product => product._id === val)
            );
            setTempSelectedProducts(newSelectedProducts);
        }
    };


    const handleProductSelect = (productId) => {
        const newSelectedProducts = tempSelectedProducts.includes(productId)
            ? tempSelectedProducts.filter(id => id !== productId)
            : [...tempSelectedProducts, productId];
        
        setTempSelectedProducts(newSelectedProducts);
        
        // Update the main tempValue as well
        const newValues = tempValue.includes(productId)
            ? tempValue.filter(val => val !== productId)
            : [...tempValue, productId];
        setTempValue(newValues);
    };

    const handleSelectAllProducts = () => {
        const allProductIds = getActiveSectionItems().map(product => product._id || product.value);
        
        if (tempSelectedProducts?.length === allProductIds?.length) {
            // Deselect all
            const newValues = tempValue.filter(val => !allProductIds.includes(val));
            setTempValue(newValues);
            setTempSelectedProducts([]);
        } else {
            // Select all
            const newValues = [...new Set([...tempValue, ...allProductIds])];
            setTempValue(newValues);
            setTempSelectedProducts(allProductIds);
        }
    };
    const handleSelectAllServices = () => {
        const activeServiceItems = getActiveSectionItems().map(service => service._id || service.value);
        
        if (tempSelectedServices.length === activeServiceItems.length && activeServiceItems.length > 0) {
            // Deselect all
            const newValues = tempValue.filter(val => !activeServiceItems.includes(val));
            setTempValue(newValues);
            setTempSelectedServices([]);
        } else {
            // Select all
            const newValues = [...new Set([...tempValue, ...activeServiceItems])];
            setTempValue(newValues);
            setTempSelectedServices(activeServiceItems);
        }
    };

    const handleClear = () => {
        setTempValue([]);
        setTempStartDate('');
        setTempEndDate('');
        setTempHasDues(false);
        setTempAvailablity(false)
        setTempSelectedProducts([]);
        dispatch(resetBillingSearchAndFilters());
    };

    const handleDateChange = (startDate, endDate) => {
        setTempStartDate(startDate);
        setTempEndDate(endDate);
    };

    const handleClickOutside = (event) => {
        if (selectRef.current && !selectRef.current.contains(event.target)) {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const hasActiveFilters = () => {
        return tempValue?.length > 0 || (tempStartDate && tempEndDate) || hasDues || hasAvailability;
    };

    const getFilterCount = (sectionTitle) => {
        if (sectionTitle === 'Date Range') {
            return (tempStartDate && tempEndDate) ? 1 : 0;
        }
        if (sectionTitle === 'Dues') {
            return tempHasDues ? 1 : 0;
        }
               if (sectionTitle === 'Deleted Bill') {
            return tempAvailablity ? 1 : 0;
        }
        if (sectionTitle === 'Products') {
            return tempSelectedProducts?.length;
        }

        const section = options?.find(opt => opt.title === sectionTitle);
        if (!section) return 0;

        return tempValue?.filter(val =>
            section.items.some(item =>
                item.value === val || item._id === val
            )
        )?.length;
    };

    const getActiveSectionItems = () => {
        if (!activeSection) return [];
        
        // Handle Products section
        if (activeSection === 'Products') {
            let productItems = products;
            
            // Apply search filter if there's a search query
            if (searchQuery) {
                productItems = productItems?.filter(product =>
                    (product.consumeableProductName || product.productName || '')
                        .toLowerCase()
                        .includes(searchQuery.toLowerCase())
                );
            }
            
            return productItems;
        }
        
        const section = options.find(opt => opt.title === activeSection);
        if (!section) return [];

        const items = section.items || [];

        if (['Services', 'Service Providers'].includes(activeSection) && searchQuery) {
            return items.filter(item => {
                const label = item.label || item.name || item.serviceName || '';
                return label.toLowerCase().includes(searchQuery.toLowerCase());
            });
        }

        return items;
    };

    const renderLoadingState = () => (
        <div className="loading-state">
            <div className="loading-spinner"></div>
            <span>Loading...</span>
        </div>
    );

    useEffect(() => {
        setTempValue(value);
        setTempHasDues(hasDues);
        setTempAvailablity(hasAvailability);
        setTempStartDate(selectedStartDate);
        setTempEndDate(selectedEndDate);
        setTempSelectedProducts(value?.filter(val => 
            products.some(product => product._id === val)
        ));
         setTempSelectedServices(value.filter(val =>
            options.find(opt => opt.title === 'Services')?.items.some(service => service.value === val || service._id === val)
        ));
    }, [value, selectedStartDate, selectedEndDate, products, options, hasDues, hasAvailability]);
 


    return (
        <div className="myntra-filter">
            <div
                className={`filter-header ${hasActiveFilters() ? 'has-filters' : ''}`}
                onClick={handleToggle}
            >
                <FiFilter className="filter-icon" size={24} />
                <span className="filter-placeholder">
                    {placeholder}
                    {hasActiveFilters() && (
                        <span className="filter-count-badge">
                            {tempValue?.length + ((tempStartDate && tempEndDate) ? 1 : 0) + (hasDues ? 1 : 0) +  (hasAvailability?1:0)}
                        </span>
                    )}
                </span>
            </div>

            {isOpen && (
                <div className="filter-overlay">
                    <div className="filter-container" style={{ width: '700px' }} ref={selectRef}>
                        <div className="filter-sidebar">
                            <div className="filter-title">Filters</div>
                            
                            {/* Date Range at the top */}
                            <div
                                className={`sidebar-item ${activeSection === 'Date Range' ? 'active' : ''}`}
                                onClick={() => {
                                    setActiveSection('Date Range');
                                    setSearchQuery('');
                                }}
                            >
                                <span>Date Range</span>
                                {getFilterCount('Date Range') > 0 && (
                                    <span className="filter-badge">1</span>
                                )}
                            </div>

                            {/* Dues filter */}
                            <div
                                className={`sidebar-item ${activeSection === 'Dues' ? 'active' : ''}`}
                                onClick={() => {
                                    setActiveSection('Dues');
                                    setSearchQuery('');
                                }}
                            >
                                <span>Dues</span>
                                {hasDues && <span className="filter-badge">1</span>}
                            </div>

                              {/* Deleted Bill filter */}
                            <div
                                className={`sidebar-item ${activeSection === 'Deleted Bill' ? 'active' : ''}`}
                                onClick={() => {
                                    setActiveSection('Deleted Bill');
                                    setSearchQuery('');
                                }}
                            >
                                <span>Deleted Bill</span>
                                {hasAvailability && <span className="filter-badge">1</span>}
                            </div>

                            {/* Other filters including Products */}
                            {options.map((section) => {
                                const count = getFilterCount(section.title);
                                return (
                                    <div
                                        key={section.title}
                                        className={`sidebar-item ${activeSection === section.title ? 'active' : ''}`}
                                        onClick={() => {
                                            setActiveSection(section.title);
                                            setSearchQuery('');
                                        }}
                                    >
                                        <span>{section.title}</span>
                                        {count > 0 && <span className="filter-badge">{count}</span>}
                                    </div>
                                );
                            })}
                        </div>

                        <div className="filter-content">
                            <div className="filter-footer">
                                <button
                                    className="clear-btn"
                                    onClick={handleClear}
                                    disabled={!hasActiveFilters()}
                                >
                                    CLEAR ALL
                                </button>
                                <button
                                    className="apply-btn"
                                    onClick={() => {
                                        onChange(tempValue);
                                        onDateRangeSelected(tempStartDate, tempEndDate);
                                        onToggleDues(tempHasDues);
                                        onToggleAvailability(tempAvailablity)
                                        if (onProductSelectionChange) {
                                            onProductSelectionChange(tempSelectedProducts);
                                        }
                                        setIsOpen(false);
                                    }}
                                >
                                    APPLY
                                </button>
                            </div>

                            <div className="scrollable-content">
                                {/* Dues content section */}
                                {activeSection === 'Dues' && (
                                    <>
                                        {/* <div className="content-section">
                                            <div className="content-title">Dues</div>
                                        </div> */}
                                        <div className="content-options">
                                            <div className="option-item">
                                                <input
                                                    type="checkbox"
                                                    id="dues-checkbox"
                                                    checked={tempHasDues}
                                                    onChange={handleDuesToggle}
                                                />
                                                <label htmlFor="dues-checkbox">
                                                    Show only bills with dues
                                                </label>
                                            </div>
                                        </div>
                                    </>
                                )}

                                  {/* Deleted Bill section */}
                                {activeSection === 'Deleted Bill' && (
                                    <>
                                        {/* <div className="content-section">
                                            <div className="content-title">Deleted Bill</div>
                                        </div> */}
                                        <div className="content-options">
                                            <div className="option-item">
                                                <input
                                                    type="checkbox"
                                                    id="dues-checkbox"
                                                    checked={tempAvailablity}
                                                    onChange={handleAvailablityToggle}
                                                />
                                                <label htmlFor="dues-checkbox">
                                                    Show Deleted Bill
                                                </label>
                                            </div>
                                        </div>
                                    </>
                                )}

                                {/* Date Range content section */}
                                {activeSection === 'Date Range' && (
                                    <>
                                        {/* <div className="content-section">
                                            <div className="content-title">Date Range</div>
                                        </div> */}
                                        <div className="date-range-container">
                                            <div className="date-input-group">
                                                <label>From</label>
                                                <input
                                                    type="date"
                                                    value={tempStartDate || ''}
                                                    onChange={(e) => handleDateChange(e.target.value, tempEndDate)}
                                                />
                                            </div>
                                            <div className="date-input-group">
                                                <label>To</label>
                                                <input
                                                    type="date"
                                                    value={tempEndDate || ''}
                                                    onChange={(e) => handleDateChange(tempStartDate, e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </>
                                )}

                                {/* Products content section */}
                                {activeSection === 'Products' && (
                                    <>
                                        <div className="content-section">
                                             <div className="content-title">
                                                <span>{activeSection}</span>
                                            </div>
                                            {/* <div className="content-title">Products</div> */}
                                            <div className="search-input-container">
                                                <input
                                                    type="text"
                                                    placeholder="Search products..."
                                                    value={searchQuery}
                                                    onChange={(e) => setSearchQuery(e.target.value)}
                                                    className="search-input wide-search"
                                                />
                                            </div>
                                        </div>
                                        <div className="content-options">
                                            {getActiveSectionItems()?.length === 0 ? (
                                                <div className="no-results">No results found.</div>
                                            ) : (
                                                <>
                                                    <div className="option-item select-all">
                                                        <input
                                                            type="checkbox"
                                                            id="select-all-products"
                                                            checked={tempSelectedProducts?.length === getActiveSectionItems()?.length && getActiveSectionItems()?.length > 0}
                                                            onChange={handleSelectAllProducts}
                                                        />
                                                        <label htmlFor="select-all-products">
                                                            Select All
                                                        </label>
                                                    </div>
                                                    {getActiveSectionItems().map((product) => (
                                                        <div key={product._id || product.value} className="option-item">
                                                            <input
                                                                type="checkbox"
                                                                id={product._id || product.value}
                                                                checked={tempSelectedProducts.includes(product._id || product.value)}
                                                                onChange={() => handleProductSelect(product._id || product.value)}
                                                            />
                                                            <label htmlFor={product._id || product.value}>
                                                                {product.consumeableProductName || product.productName || product.label}
                                                            </label>
                                                        </div>
                                                    ))}
                                                </>
                                            )}
                                        </div>
                                    </>
                                )}

                                {/* Other filters content sections */}
                                {activeSection && activeSection !== 'Date Range' && activeSection !== 'Dues' && activeSection !== 'Products' && activeSection !== 'Deleted Bill' && (
                                    <>
                                        <div className="content-section">
                                            <div className="content-title">
                                                <span>{activeSection}</span>
                                            </div>
                                            {(activeSection === 'Services' || activeSection === 'Service Providers') && (
                                                <div className="search-input-container">
                                                    <input
                                                        type="text"
                                                        placeholder={`Search ${activeSection.toLowerCase()}...`}
                                                        value={searchQuery}
                                                        onChange={(e) => setSearchQuery(e.target.value)}
                                                        className={`search-input ${activeSection === 'Services' || activeSection === 'Service Providers' ? 'wide-search' : ''}`}
                                                    />
                                                </div>
                                            )}
                                        </div>

                                        <div className="content-options">
                                            {(activeSection === 'Services' && loadingServices) ||
                                                (activeSection === 'Service Providers' && loadingProviders) ? (
                                                renderLoadingState()
                                            ) : (
                                                getActiveSectionItems().length === 0 ? (
                                                    <div className="no-results">No results found.</div>
                                                ) : (
                                                    <>
                                                        {activeSection === 'Services' && (
                                                            <div className="option-item select-all">
                                                                <input
                                                                    type="checkbox"
                                                                    id="select-all-services"
                                                                    checked={tempSelectedServices.length === getActiveSectionItems().length && getActiveSectionItems().length > 0}
                                                                    onChange={handleSelectAllServices}
                                                                />
                                                                <label htmlFor="select-all-services">
                                                                    Select All
                                                                </label>
                                                            </div>
                                                        )}
                                                        {getActiveSectionItems().map((option) => (
                                                            <div key={option.value || option._id} className="option-item">
                                                                <input
                                                                    type="checkbox"
                                                                    id={option.value || option._id}
                                                                    checked={tempValue.includes(option.value || option._id)}
                                                                    onChange={() => handleTempOptionChange(option.value || option._id, activeSection)}
                                                                />
                                                                <label htmlFor={option.value || option._id}>
                                                                    {option.label || option.name || option.serviceName}
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </>
                                                )
                                            )}
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default FilterBillPage;


